import React, { FC } from 'react';

interface IVideoProps {
  src: string;
  width?: number | string;
  height?: number | string;
  controls?: boolean;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  poster?: string;
  className?: string;
  onCanPlay?: () => void;
}

const Video: FC<IVideoProps> = ({
  src,
  width = 1280,
  height = 720,
  controls = true,
  autoPlay = false,
  loop = false,
  muted = false,
  poster,
  className,
  onCanPlay,
}) => {
  return (
    <>
      <video
        src={src}
        className={className}
        width={width}
        height={height}
        controls={controls}
        autoPlay={autoPlay}
        loop={loop}
        poster={poster}
        muted={muted}
        controlsList="nodownload"
        onCanPlay={onCanPlay}
      />
    </>
  );
};

export default Video;
